<template>
	<el-dialog
		:modelValue="open"
		@update:modelValue="$emit('update:open', $event)"
		:title="'Rückfrage'"
		@close="$emit('close')"
		id="callbackDetailDialog"
	>
		<template v-if="callbackObject">
			<small>Rückfrage</small>
			<span v-if="callbackObject.createdDate">{{ $formatDate(callbackObject.createdDate) }}</span>
			<div class="callbackDetail__text">{{ callbackObject.text }}</div>

			<small>Antwort</small>
			<span v-if="callbackObject.answeredDate">{{ $formatDate(callbackObject.answeredDate) }}</span>
			<div>{{ callbackObject.answer ? callbackObject.answer : '-' }}</div>
		</template>
		<template #footer>
			<div class="button-panel">
				<TheButton type="default" @buttonclick="$emit('close')">Schließen</TheButton>
			</div>
		</template>
	</el-dialog>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue';
import { CallbackResponse } from '../../types/types';
import type { PropType } from 'vue';
import TheButton from '../TheButton.vue';

export default defineComponent({
	name: 'DialogCallbackDetail',
	data() {
		return {};
	},
	props: {
		open: {
			type: Boolean,
			required: true,
		},
		callbackObject: {
			type: Object as PropType<CallbackResponse | null>,
		},
	},
	components: {
		TheButton,
	},
	emits: ['close', 'update:open'],
	computed: {},
});
</script>

<style lang="scss">
#callbackDetailDialog {
	.el-dialog__body {
		> * {
			display: inline-block;
			width: 100%;
			padding-top: 0.3rem;
			font-size: 1rem;
		}

		small {
			font-size: 0.75rem;
			font-weight: 500;
		}

		.callbackDetail__text {
			margin-bottom: 2rem;
		}
	}
}
</style>
